import moment from "@/utils/moment";

const MAX_TIME_TO_PAY = 1200;

export default {
  data() {
    return {
      fromTime: null,
      duration: null,
      time: null,
      start: null,
      currentServerTime: moment().unix(),
      delta: null,
      timeout: null
    };
  },

  methods: {
    diffTime() {
      this.delta = Math.floor((Date.now() - this.start) / 1000);
    },

    timeLeft(serverTime) {
      const timeElapsed = serverTime - moment(this.fromTime).unix();

      if (timeElapsed > this.duration - 1) {
        return false;
      }

      return Math.max(this.duration - timeElapsed, 0);
    },

    countdown() {
      this.diffTime();
      const timeLeft = this.timeLeft(this.currentTime);

      if (!timeLeft) {
        this.time = null;
        return this.onTimeout && this.onTimeout();
      }

      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      this.time = `${("0" + minutes).slice(-2)}:${("0" + seconds).slice(-2)}`;
      this.timeout = setTimeout(this.countdown, 1000);
    },

    percentageTimeLeft() {
      return Math.max(
        (this.timeLeft(this.currentTime) / this.duration) * 100,
        0
      );
    },

    percentageTimeCompleted() {
      return Math.min(
        100 - (this.timeLeft(this.currentTime) / this.duration) * 100,
        100
      );
    },

    startCountDown(
      from,
      duration = MAX_TIME_TO_PAY,
      serverTime = moment().unix()
    ) {
      this.fromTime = from;
      this.duration = duration;

      this.currentServerTime = serverTime;
      this.start = Date.now();

      this.countdown();
    }
  },

  computed: {
    inTimeToPay: function() {
      return this.time;
    },

    currentTime: function() {
      return this.currentServerTime + this.delta;
    }
  },

  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/countdownMixin.js